export default __webpack_public_path__ + "static/media/Play_Rock.46aecf35.png";